var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGaslocationtank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 43.349 43.349",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    fillRule: "evenodd",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#474f54",
    d: "M21.657 7.923a.481.481 0 0 1-.493-.493V4.963c0-.653.986-.653.986 0V7.43c.035.247-.211.493-.493.493z",
    opacity: 1,
    "data-original": "#474f54"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#474f54",
    d: "M23.03 5.457H20.32c-.654 0-.654-.986 0-.986h2.711c.654 0 .654.986 0 .986z",
    opacity: 1,
    "data-original": "#474f54"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de333f",
    d: "M17.748 7.923c-.22 0-1.863-.13-2.57-.32v.003c.034.281-.212.493-.494.493a.481.481 0 0 1-.493-.493V2.64c0-.545.685-.635.913-.272.783-.363 3.137-.273 3.137.272v4.754c0 .282-.211.528-.493.528zM25.601 7.923a.481.481 0 0 1-.493-.493V2.64c0-.535.662-.632.901-.29.826-.342 3.114-.245 3.114.29v4.966c.035.281-.211.493-.493.493-.23 0-2.01-.14-2.67-.343a.473.473 0 0 1-.359.166z",
    opacity: 1,
    "data-original": "#de333f",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#474f54",
    d: "M29.334 43.315H14.015c-.377 0-.614-.423-.458-.74l1.233-2.535c.323-.612 9.286.954 12.819.458-.312-.587.641-1.06.915-.423l1.233 2.536c.16.323-.08.704-.423.704z",
    opacity: 1,
    "data-original": "#474f54"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e45963",
    d: "M27.01 40.85H16.34c-4.192 0-7.608-3.416-7.608-7.607V14.508c0-4.19 3.416-7.607 7.607-7.607h10.67c4.192 0 7.608 3.416 7.608 7.607v18.735c0 4.191-3.416 7.607-7.607 7.607z",
    opacity: 1,
    "data-original": "#e45963",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de333f",
    d: "M8.776 34.053a7.66 7.66 0 0 1-.044-.81V14.508c0-.274.016-.544.044-.81h25.797c.029.266.044.536.044.81v18.735c0 .274-.015.544-.044.81z",
    opacity: 1,
    "data-original": "#de333f",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efc742",
    d: "M20.953 32.82h-.07c-1.938-.246-3.452-1.302-4.368-3.063-1.232-2.43-1.197-5.952.141-8.382.248-.47.991-.286.951.282 0 .07-.07 1.48.634 2.29-.81-3.311.14-7.326 3.416-8.981.356-.196.842.128.74.599-.88 3.275 1.267 5.81 3.556 7.113 3.14 1.791 1.822 8.695-2.253 10.072-.47.159-.938-.416-.529-.845 0 0 1.48-1.62 1.233-4.12 0-.035-.176-1.902-1.198-3.205.225 1.423-.21 2.14-.21 2.148-.071.07-.776 1.162-1.515 1.585-.247.176-.916.775-.916 1.268 0 .179-.336 1.795.67 2.324a.504.504 0 0 1 .246.599c-.141.176-.317.317-.528.317z",
    opacity: 1,
    "data-original": "#efc742"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de333f",
    d: "M29.563 3.133H13.784c-.845 0-1.55-.704-1.55-1.55S12.94.035 13.786.035h15.777c.846 0 1.55.704 1.55 1.55.035.88-.67 1.55-1.55 1.55z",
    opacity: 1,
    "data-original": "#de333f",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGaslocationtank);
export default __webpack_public_path__ + "static/media/gaslocationtank.97e461609732a6b1b8cfd1cb63b76d07.svg";
export { ForwardRef as ReactComponent };